module.exports = __webpack_public_path__ + "img/1577156456.7efb1622.jpg";